module.exports = __webpack_public_path__ + "static/media/coffee.95a76351.svg";